export const ASSIGN_UNASSIGN_STATUS_MESSAGES = {
  ASSIGNED: {
    individual: '{{STUDENT_NAME}} assignment has been Assigned',
    single: '1 student assignment has been Assigned',
    multiple: '{{STUDENTS_COUNT}} student assignments have been Assigned',
  },
  UN_ASSIGNED: {
    individual: '{{STUDENT_NAME}} assignment has been Unassigned',
    single: '1 student assignment has been Unassigned',
    multiple: '{{STUDENTS_COUNT}} student assignments have been Unassigned',
  },
};

export const LOCK_UNLOCK_STATUS_MESSAGES = {
  ASSIGNED: {
    individual: '{{STUDENTS_COUNT}} assignment has been Unlocked.',
    single: '{{STUDENTS_COUNT}} student assignment has been Unlocked',
    multiple: '{{STUDENTS_COUNT}} student assignments have been Unlocked',
  },
  UN_ASSIGNED: {
    individual: '{{STUDENT_NAME}} assignment has been Locked',
    single: '1 student assignment has been Locked.',
    multiple: '{{STUDENTS_COUNT}} student assignments has been Locked',
  },
};
